export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
    },
    filters: {
      withAll: "Mit allen",
      withoutAny: "Ohne einen",
      withPlayer: "Mit {{player}}",
      withoutPlayer: "Ohne {{player}}",
      all: "Alle",
      versusPosition: "vs {{position}}",
      starter: "Starter",
      nonStarter: "Kein Starter",
      starterAndNonStarter: "Starter + kein Starter",
      betType: "Wetttyp",
      timeframe: "Zeitraum",
      splits: "Splits",
      with: "Mit",
      without: "Ohne",
      opponent: "Gegner",
    },
    actions: {
      applyFilter: "Filter anwenden",
      applied: "Angewendet",
    },
    banners: {
      notPlayingToday: "{{entity}} spielt heute nicht",
    },
    sections: {
      stats: "Stats",
      seasonStats: "Saison-Stats",
      last3Seasons: "Letzte 3 Saisons",
      batterVsPitcherGamelog: "Batter-vs.-Pitcher-Gamelog anzeigen",
    },
    stats: {
      perGame: "Pro Spiel",
      total: "Gesamt",
      timeframe: "Zeitraum",
      filters: "Filter",
      season: "Saison",
    },
    headers: {
      type: "Typ",
      hitRate: "Trefferquote",
      odds: "Quoten",
      stat: "Stat",
      average: "Durchschnitt",
    },
    outcomes: {
      covered: "Gedeckt",
      yes: "Ja",
      no: "Nein",
      win: "S",
      loss: "N",
      tie: "UNENTSCHIEDEN",
    },
    alerts: {
      imageSavedToDevice: "Bild auf Gerät gespeichert",
    },
  },
};
